import { memo } from "react";
import Service, { type ServiceProps } from "../Service";
import AdditionalOptions from "./AdditionalOptions";

const AddressVerification = (props: Omit<ServiceProps, 'serviceLabel'>) => (
    <Service
        {...props}
        serviceLabel='Address Verification'
        additionalOptionsSlot={(
            <AdditionalOptions />
        )}
    />
);

export default memo(AddressVerification);
